<template>
  <div class="allContent">
    <div class="userInfo">
      <div class="userImg">
        <img :src="state.userAvatar" alt="" />
      </div>
      <div class="userText">
        <div class="userName">{{ state.userName }}</div>
        <div class="userTime" v-if="!state.monthcardFlag">
          未开通·开通尊享特权福利
        </div>
        <div class="userTime" v-else>到期时间：{{ state.time }}</div>
      </div>
      <div class="userHistoty">
        <span @click="goGetRecord">
          领取记录
        </span>
      </div>
    </div>

    <div class="cardInfo">
      <div class="buyCard">
        <div class="cardRule" @click="$router.push('/newmonthCardDesc')">
          <img
            src="../../../assets/yz/monthIcon/yz_newMonth_slice.png"
            alt=""
          />
          <span>
            0.1折手游省钱月卡购买及使用规则
          </span>
          <img src="../../../assets/yz/monthIcon/yz_newMonth_go.png" alt="" />
        </div>
        <div class="cardDetails">
          <li
            @click="selectCard(item)"
            v-for="(item, index) in state.monthCardInfo"
            :class="[state.activeNum === item.id ? 'active' : '']"
          >
            <p>{{ item.name }}</p>
            <p v-if="item.jiazhi">{{ item.jiazhi }}元</p>
            <p v-else class="emptyMoney"></p>
            <p>{{ item.amount }}<span>元</span></p>
            <div v-if="item.title">{{ item.title }}</div>
          </li>
        </div>
        <div class="yuqInfo">
          <p>
            价值{{ state.cardValue }}元,每天领1张<span>满6减6元</span>优惠券
          </p>
        </div>
      </div>

      <div class="yhqDetail">
        <div class="yhq_top">
          <div>
            <p>每天1张满6减6优惠券</p>
            <span
              >每天手动领取1张满6减6优惠券，领取后1天
              有效期，适用于平台内所有游戏。</span
            >
          </div>
          <img src="../../../assets/yz/monthIcon/yz_newMonth_yhq.png" alt="" />
        </div>
        <div class="getCoupon" @click="getCoupon">
          领取优惠券
        </div>
      </div>

      <div class="yhqDetail lbDetail">
        <div class="yhq_top">
          <img src="../../../assets/yz/monthIcon/yz_newMonth_lb.png" alt="" />
          <div>
            <p>月卡专属礼包</p>
            <span>部分游戏可领取月卡专属礼包</span>
          </div>
        </div>
      </div>

      <div class="yhqDetail rzDetail">
        <div class="yhq_top">
          <div>
            <p>月卡身份专属认证</p>
            <span>社交等功能头像右侧显示认证图标</span>
          </div>
          <img src="../../../assets/yz/monthIcon/yz_newMonth_rz.png" alt="" />
        </div>
      </div>
    </div>

    <div class="goBuyCard">
      <p @click="openCard" v-if="!state.monthcardFlag">
        立即开通 ({{ state.amount }}元)
      </p>
      <p v-else @click="openCard">立即续费 ({{ state.amount }}元)</p>
    </div>

    <!-- 支付弹窗 -->
    <!-- vip弹窗 -->
    <van-popup v-model:show="state.show" round position="bottom">
      <div class="popup-box">
        <p class="pop-title">购买月卡</p>
        <h3><span>¥</span>{{ state.amount }}</h3>
        <ul>
          <li @click="goSell('zfb')">
            <div>
              <img src="../../../assets/personal/ico_zfbzf.png" /> 支付宝支付
            </div>
          </li>
          <li @click="goSell('wx')">
            <div>
              <img src="../../../assets/personal/ico_wxzf.png" /> 微信支付
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import { useRouter, onBeforeRouteUpdate } from "vue-router";

import { useStore } from "vuex";

import { reactive, onDeactivated, onActivated } from "vue";

// import { monthCardInfo, monthCardGet, McStatus } from "@/api/yzuser";

import { newWxpayMonth, newAlipayMonth } from "@/api/yzpay";

import { Toast } from "vant";

import { detect, randomString } from "@/utils/device";

import { getQueryString } from "@/utils/location";
import { setToken, removeToken } from "@/utils/auth";

import { encrypt, decrypt } from "@/utils/rsa";

const router = useRouter();
const store = useStore();

const state = reactive({
  userName: "",
  userAvatar: "",
  activeNum: "",
  userId: "",
  uid: "",
  monthCardInfo: [],
  amount: 30,
  // 支付弹窗
  show: false,
  time: "",
  monthcardFlag: false,
  cardValue: "",
  day: 0,
  number: 0,
  pay: "",
  money: 0,
});

onActivated(() => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }

  // 清除cookie

  state.userAvatar = getQueryString("avatar");
  state.userName = getQueryString("name");
  state.userId = getQueryString("username");
  state.uid = getQueryString("uid");
  state.activeNum = 1;

  // 获取月卡信息
  getMonthCardInfo();

  // 获取用户月卡状态
  getUserMonth();
});

// 获取用户月卡状态
const getUserMonth = () => {
  McStatus({ username: state.userId }).then((response) => {
    // console.log('用户月卡状态返回的数据',response)
    if (response.data.monthcard == 1) {
      state.time = response.data.endtime.slice(0, 10);
      state.monthcardFlag = true;
    } else {
      state.monthcardFlag = false;
    }
  });
};

onDeactivated(() => {});

// 跳转至月卡开通记录页
const goOpenRecord = () => {
  router.push({
    path: "/newopen_record",
    query: {
      uid: state.uid,
    },
  });
};
// 跳转至月卡领取记录页
const goGetRecord = () => {
  // router.push({
  //     path: '/get_record',
  //     query: {
  //         uid: state.uid
  //     }
  // })
  let title = "领取记录";
  window.document.location = "getrecord://" + title;
};

// onBeforeRouteUpdate((to, from, next) => {
//   console.log("页面更新------------------------------");
//   next(window.scrollTo(0, 0), getMonthCardInfo(), getUserMonth());
// });

// 选择套餐
const selectCard = (data) => {
  // console.log('点击的是哪一个数据---------',data)
  state.activeNum = data.id;
  state.amount = data.amount;
  state.cardValue = data.jiazhi;
  state.day = data.name;
  state.number = data.buyday;
  state.money = data.money;

  // console.log('点击的是哪一个数据---------',state)
};

// 领取优惠券
var fetchFlag = false;
const getCoupon = async () => {
  if (fetchFlag) return;
  fetchFlag = true;
  const res = await monthCardGet({ uid: state.uid, imei: "" });
  if (res.data.code == "1") {
    Toast("领取成功");
  } else {
    Toast(res.data.msg);
  }
  fetchFlag = false;
  // console.log('领取优惠券------------------',res)
};

// 开通月卡
const openCard = () => {
  state.show = true;
};

// 获取月卡信息
const getMonthCardInfo = async () => {
  const res = await monthCardInfo({ uid: state.uid });
  if (res.data.code == "1") {
    state.monthCardInfo = res.data.data;
    state.cardValue = res.data.data[0].jiazhi;

    state.day = res.data.data[0].name;
    state.number = res.data.data[0].buyday;
    state.amount = res.data.data[0].amount;
    state.money = res.data.data[0].money;
    // console.log("月卡信息------------------", state.monthCardInfo);
  } else {
    Toast(res.data.msg);
  }
};

// 购买会员
const goSell = async (zf) => {
  state.pay = zf;
  let type = detect();
  let paydata = {
    z: "",
    b: state.amount,
    c: state.userId,
    os: type,
    pr: state.number,
    money: state.money,
    number: state.number,
    x: "zksq_yueka_" + zf + "_" + randomString(5) + Date.now(),
    cash: 0,
  };
  if (zf == "zfb") {
    paydata.z = "zfb";
    console.log(paydata);

        window.document.location = "payalimonthcard://" + JSON.stringify(paydata);
    // newAlipayMonth(paydata).then(response => {
    //   console.log(response.data.data)
    // //   debugger
    //     if(response.data.code == 1){
    //         // window.document.location ="gogame://" + '549'

    //     }else{
    //         Toast(response.data.msg)
    //     }
    // })
  } else {
    paydata.z = "wx";
    // console.log(paydata)
    // window.document.location = "orderIdPayweixinmonthcard://" + '_orderId'+paydata.x+'_money'+paydata.b;
    newWxpayMonth(paydata).then((response) => {
      // console.log(response)
      if (response.data.code == 1) {
        window.document.location =
          "payweixinmonthcard://" +
          response.data.data +
          "_orderId" +
          paydata.x +
          "_money" +
          paydata.b;
      } else {
        Toast(response.data.msg);
      }
    });
  }
  state.show = false;
};

// beforeRouteLeave((to, from, next) => {
//     // console.log('离开页面------------------')
//     // 回到顶部
//     document.documentElement.scrollTop = 0;
// })
</script>

<style src="../../../styles/van-sticky-nav.css"></style>
<style scoped>
:deep(.van-overlay) {
  background-color: #0000003c;
}
.van-nav-bar {
  background: rgba(255, 255, 255, 0);
}

.right-nr {
  color: #666666;
  font-size: 24px;
}
.allContent {
  width: 100%;
  min-height: 100vh;
  background-color: #f2f2f3;
  /* padding-bottom: 100px; */
  padding-top: calc(100px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(100px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_bg.png);
  background-size: 100% 442px;
  background-repeat: no-repeat;
  background-position-y: -95px;
  padding-bottom: 200px;
}

.userInfo {
  width: 100%;
  height: 208px;
  display: flex;
  align-items: center;
  padding-left: 80px;
}

.userInfo img {
  width: 120px;
  height: 120px;
  margin-right: 24px;
  border-radius: 50%;
}

.userInfo .userText .userName {
  color: #333;
  font-size: 28px;
}

.userInfo .userText .userTime {
  color: #777777;
  font-size: 20px;
  margin-top: 12px;
}

.userInfo .userHistoty {
  margin-left: 80px;
  width: 136px;
  height: 50px;
  background: linear-gradient(90deg, #96deda 0%, #50c9c3 100%);
  border-radius: 100px 100px 100px 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.cardInfo {
  padding: 0 32px;
}

.cardInfo .buyCard {
  width: 100%;
  height: 454px;
  background-color: #fff;
  border-radius: 30px;
  padding: 40px 24px;
}

.buyCard .cardRule {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333;
  font-weight: 800;
  background-color: #eafaf7;
  padding: 14px 20px;
  margin-bottom: 50px;
  border-radius: 10px;
}

.buyCard .cardRule img {
  width: 24px;
  height: 24px;
}

.buyCard .cardRule img:nth-of-type(1) {
  margin-right: 12px;
}

.buyCard .cardRule span {
  margin-right: 210px;
}

.buyCard .cardDetails {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.buyCard .cardDetails li {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background: #f9fdfd;
  border-radius: 20px 20px 20px 20px;
  border: 2px solid #e0e0e0;
  padding: 32px 0;
  position: relative;
}

.buyCard .cardDetails li.active {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_select.png);
  background-repeat: no-repeat;
  background-size: cover;
  border: none;
  color: #12cec7;
}
.buyCard .cardDetails li.active p:nth-last-of-type(1) {
  color: #12cec7;
}

.buyCard .cardDetails li p:nth-of-type(1) {
  color: #333;
  font-size: 24px;
  font-weight: 800;
  margin-top: 32px;
  margin-bottom: 8px;
}
.buyCard .cardDetails li p:nth-of-type(2) {
  color: #8f9197;
  font-size: 20px;
  text-decoration: line-through;
}

.buyCard .cardDetails li p:nth-last-of-type(1) {
  color: #333;
  font-size: 64px;
  font-weight: 800;
  margin-bottom: 8px;
}
.buyCard .cardDetails li p span {
  font-size: 16px;
}
.buyCard .cardDetails li div {
  color: #666666;
  font-size: 20px;
  font-weight: 500;
  position: absolute;
  top: -18px;
  left: 12px;
  /* width: 96px; */
  padding: 0 8px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(99deg, #ff6666 0%, #ffac5f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.buyCard .yuqInfo {
  background-image: url(../../../assets/yz/monthIcon/yz_newMonth_yhqInfo.png);
  background-repeat: no-repeat;
  background-size: contain;
  padding: 14px 32px 14px 68px;
  color: #12cec7;
  font-size: 20px;
  margin-top: 20px;
}
.buyCard .yuqInfo p span {
  /* color: #ff6666; */
  font-size: 20px;
}
.yhqDetail {
  /* height: 304px; */
  background-color: #fff;
  border-radius: 30px;
  margin: 26px 0 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 24px 34px 24px;
}
.yhqDetail .yhq_top {
  display: flex;
  justify-content: space-around;
  margin-bottom: 32px;
}
.yhqDetail .yhq_top img {
  width: 152px;
  height: 152px;
}

.yhqDetail .yhq_top > div {
  width: 486px;
}
.yhqDetail .yhq_top > div p {
  font-size: 32px;
  font-weight: 800;
  color: #333;
  margin-bottom: 12px;
}
.yhqDetail .yhq_top > div span {
  color: #666666;
  font-size: 24px;
  display: inline-block;
  width: 428px;
}
.lbDetail .yhq_top > div span {
  color: #666666;
  font-size: 24px;
  display: inline-block;
  width: 428px;
  display: flex;
  justify-content: end;
}
.yhqDetail .getCoupon {
  height: 84px;
  width: 100%;
  border-radius: 100px;
  background: linear-gradient(90deg, #96deda 0%, #50c9c3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
  font-weight: 500;
}
.lbDetail {
  padding: 28px 0;
}
.lbDetail .yhq_top {
  margin-bottom: 28px;
}
.lbDetail .yhq_top > div {
  margin-right: 0;
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: center;
}
.rzDetail {
  padding: 28px 0;
}
.rzDetail .yhq_top {
  margin-bottom: 28px;
}
.rzDetail .yhq_top > div {
  margin-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.goBuyCard {
  position: fixed;
  bottom: 0;
  height: 188px;
  width: 100%;
  background-color: #fff;
  border-radius: 40px 40px 0 0;
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
.goBuyCard p {
  width: 638px;
  height: 84px;
  background: linear-gradient(90deg, #96deda 0%, #50c9c3 100%);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 28px;
  font-weight: bold;
}
.popup-box {
  width: 100%;
  height: 658px;
  padding: 30px;
  background-color: #fff;
}

.popup-box .pop-title {
  font-size: 32px;
  color: #333;
  font-weight: 500;
  text-align: center;
}

.popup-box h3 {
  font-size: 64px;
  color: #333;
  text-align: center;
  margin: 8px 0;
}

.popup-box h3 span {
  font-size: 32px;
}

.popup-box ul {
  margin-top: 30px;
}

.popup-box ul li {
  width: 686px;
  height: 112px;
  border-radius: 20px;
  background-color: #f1f1f1;
  line-height: 112px;
  font-size: 26px;
  margin-bottom: 20px;
  padding-left: 24px;
}

.popup-box ul li div {
  color: #333;
  font-size: 28px;
  font-weight: 500;
}

.popup-box ul li img {
  width: 50px;
  vertical-align: middle;
  margin-right: 20px;
}
.emptyMoney {
  width: 100%;
  height: 20px;
  margin-top: 30px;
}
</style>
